import {
  MEMBERS_FETCHING,
  FETCH_MEMBERS,
  FILTER_MEMBERS_BY_PATTERN,
  FIND_MEMBER,
  SET_DATA_LOADER,
  COUNT_MEMBER,
  FETCH_AUTO_ENROLLED,
} from './types'
import { memberService } from '../../server'

export const fetchMembers = () => (dispatch) => {
  dispatch({ type: MEMBERS_FETCHING })

  memberService.getAll().then((d) => {
    if (d && d.length) {
      d.forEach((m) => {
        m.fullName = `${m.firtsName} ${m.lastName} ${m.middleName}`
      })

      return dispatch({
        type: FETCH_MEMBERS,
        payload: {
          items: d,
          loaded: d,
        },
      })
    }
  })
}

export const findMember = (items, id) => (dispatch) => {
  const data = items.find((c) => c.id === id)
  if (data) {
    return dispatch({
      type: FIND_MEMBER,
      payload: data,
    })
  } else {
    memberService
      .get(id)
      .then((d) => {
        return dispatch({
          type: FIND_MEMBER,
          payload: d,
        })
      })
      .catch((e) => {
        return dispatch({
          type: FIND_MEMBER,
          payload: null,
        })
      })
  }
}

export const fetchAutoEnrolled = (item) => (dispatch) => {
  return dispatch({
    type: FETCH_AUTO_ENROLLED,
    payload: item,
  })
}

export const filterMembers = (members, pattern: string) => (dispatch) => {
  /*const pat = stringUtil.noAccent(pattern.trim().toLowerCase());
  let items = [...members];

  if (pat) {
    items = items.filter(
      (c) =>
        stringUtil.noAccent(c.brand.name.toLowerCase()).includes(pat) ||
        stringUtil.noAccent(c.model.name.toLowerCase()).includes(pat) ||
        (c.generation &&
          stringUtil.noAccent(c.generation.name.toLowerCase()).includes(pat)) ||
        stringUtil.noAccent(c.VIN.toLowerCase()).includes(pat)
    );
  }
  
  return dispatch({
    type: FILTER_MEMBERS_BY_PATTERN,
    payload: {
      items: items,
      pattern: pattern,
    },
  });
  */
}
